// extracted by mini-css-extract-plugin
export default {"wrapper":"taskSandbox_wrapper__ssOKZ","addOption":"taskSandbox_addOption__tH2Yh","imageOptionOrderingIndex":"taskSandbox_imageOptionOrderingIndex__o8kpO"};